import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { authPermissionPermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { PERMISSIONS_APPLICATIONS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_PERMISSIONS_APPLICATIONS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'permissions/applications',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "permissions.applications.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-permissions-applications-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.applications.list" */
          './PermissionsApplicationsList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: Permissions.read,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.applications.view" */
          './PermissionsApplicationsView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        meta: {
          permission: Permissions.edit,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.applications.view" */
          './PermissionsApplicationsView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.applications.view" */
          './PermissionsApplicationsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
